import { render, staticRenderFns } from "./magical_reload.vue?vue&type=template&id=d16a4d5a&"
import script from "./magical_reload.vue?vue&type=script&lang=js&"
export * from "./magical_reload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d16a4d5a')) {
      api.createRecord('d16a4d5a', component.options)
    } else {
      api.reload('d16a4d5a', component.options)
    }
    module.hot.accept("./magical_reload.vue?vue&type=template&id=d16a4d5a&", function () {
      api.rerender('d16a4d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/magical_reload.vue"
export default component.exports